<template>
    <inertia-link :href="link" v-if="buttonMode == 'iconButton'"
        class="hrm_custom_icon_button hrm_button_hover buttongroup relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg"
        :style="{ height: buttonSize, width: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
        :class="buttonClass">
        <slot>
            <Icon :icon="icon" :width="iconSize" :height="iconSize" />
        </slot>
        <span v-if="tooltipText" class="hrm_button_link_tooltip" :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
    <inertia-link :href="link" v-else-if="buttonMode == 'textButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{ height: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
        :class="buttonClass">
        <slot>
            {{ title }}
        </slot>
        <span v-if="tooltipText" class="hrm_button_link_tooltip" :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
    <inertia-link :href="link" v-else-if="buttonMode == 'iconTextButton'"
        class="hrm_custom_text_icon_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{ height: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
        :class="buttonClass">
        <slot>
            <Icon :icon="icon" :width="iconSize" :height="iconSize" />
            {{ title }}
        </slot>
        <span v-if="tooltipText" class="hrm_button_link_tooltip" :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
    <inertia-link :href="link" v-else-if="buttonMode == 'progressButton'"
        class="hrm_custom_progress_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{ height: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
        :class="buttonClass">
        <slot>
            <span v-if="loading" class="animate-spin flex items-center justify-center">
                <loading-icon />
            </span>
            {{ title }}
        </slot>
        <span v-if="tooltipText" class="hrm_button_link_tooltip" :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
</template>
<script>
import { Icon } from '@iconify/vue';
import LoadingIcon from "@/Common/LoadingIcon.vue";
export default {
    name: "ButtonCard",
    components: {
        Icon, LoadingIcon
    },
    props: {
        buttonMode: {
            type: String,
            default: "iconButton"
        },
        link: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: ""
        },
        forName: {
            type: String,
            default: ""
        },
        buttonClass: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: ""
        },
        iconSize: {
            type: String,
            default: ""
        },
        buttonSize: {
            type: String,
            default: ""
        },
        buttonPadding: {
            type: String,
            default: ""
        },
        buttonAlign: {
            type: String,
            default: ""
        },
        tooltipText: {
            type: String,
            default: ""
        },
        tooltipPosition: {
            type: String,
            default: "top"
        },

    },
    methods: {
        getTooltipPositionClass(position) {
            const positions = {
                left: 'hrm_tooltip_left',
                right: 'hrm_tooltip_right',
                top: 'hrm_tooltip_top',
                bottom: 'hrm_tooltip_bottom'
            };
            return positions[position] || ''
        }
    },
}
</script>
<style>
.hrm_custom_icon_button:hover,
.hrm_custom_text_button:hover,
.hrm_custom_text_icon_button:hover,
.hrm_custom_progress_button:hover {
    filter: brightness(120%);
}

.hrm_custom_progress_button svg path {
    fill: var(--hrm_Theme_Text_Color);
}

.hrm_button_hover:hover .hrm_button_link_tooltip {
    visibility: visible;
    opacity: 1;
}

.hrm_button_link_tooltip {
    position: absolute;
    visibility: hidden;
    background-color: #2f3336;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 9999;
    opacity: 0;
    transition: opacity 0.3s !important;
    font-size: 12px;
    font-weight: 600;
    border-radius: 6px;
}

.hrm_button_link_tooltip::after {
    content: '';
    position: absolute;
    border-style: solid;
}

/* Bottom tooltip */
.hrm_tooltip_bottom {
    top: 130%;
    left: 50%;
    transform: translateX(-50%);
}

.hrm_tooltip_bottom::after {
    top: -4px;
    left: 50%;
    transform: translate(-50%, -50%);
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent #2f3336 transparent;
}

/* Top tooltip */
.hrm_tooltip_top {
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
}

.hrm_tooltip_top::after {
    bottom: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
    border-width: 8px 8px 0 8px;
    border-color: #2f3336 transparent transparent transparent;
}

/* Left tooltip */
.hrm_tooltip_left {
    top: 50%;
    right: 126%;
    transform: translateY(-50%);
}

.hrm_tooltip_left::after {
    top: 50%;
    right: -10px;
    transform: translate(-50%, -50%);
    border-width: 8px 0 8px 8px;
    border-color: transparent transparent transparent #2f3336;
}

/* Right tooltip */
.hrm_tooltip_right {
    top: 50%;
    left: 136%;
    transform: translateY(-50%);
}

.hrm_tooltip_right::after {
    top: 50%;
    left: -4px;
    transform: translate(-50%, -50%);
    margin-top: 0;
    border-width: 8px 8px 8px 0;
    border-color: transparent #2f3336 transparent transparent;
}
</style>